module.exports = __webpack_public_path__ + "img/校验.942e932d.svg";